// React
import React from 'react'
// External libs
import classNames from 'classnames'
import { get } from 'lodash'
// Components
import CustomButton from '../buttons/custom-button'
// Styles
import useStyles from './CustomDialogFooter.styles'

const CustomDialogFooter = ({ classes, actions }) => {
  const componentClasses = useStyles()

  return (
    <div
      className={classNames(
        get(componentClasses, 'root', null),
        get(classes, 'root', null),
      )}
    >
      {!!actions &&
        !!actions.length &&
        actions.map((action, index) => {
          const actionColor = get(action, 'color', null)
          return (
            <CustomButton
              classes={{
                root: classNames(
                  get(componentClasses, 'actionRoot', null),
                  get(classes, 'actionRoot', null),
                  get(action, 'classes.root', null),
                ),
                submitButton: classNames(
                  get(componentClasses, 'actionSubmitButton', null),
                  !actionColor
                    ? get(componentClasses, 'actionSubmitButtonDefault', null)
                    : null,
                  get(classes, 'actionSubmitButton', null),
                  get(action, 'classes.submitButton', null),
                ),
              }}
              color={actionColor}
              key={`action-${index}`}
              onClick={get(action, 'onClick', () => {})}
              fullWidth={false}
              variant={get(action, 'variant', null)}
              disabled={get(action, 'disabled', false)}
            >
              {get(action, 'text', null)}
            </CustomButton>
          )
        })}
    </div>
  )
}

CustomDialogFooter.defaultProps = {
  classes: {},
}

export default CustomDialogFooter
